"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const venmologo = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 74 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-venmologo` : '') + (description ? ` desc-venmologo` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-venmologo"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-venmologo"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4891 0.0493164C12.9861 0.864568 13.2102 1.70428 13.2102 2.765C13.2102 6.14818 10.3024 10.5432 7.94235 13.6293H2.55189L0.390015 0.790051L5.10995 0.344977L6.25296 9.48091C7.32095 7.75283 8.6389 5.03714 8.6389 3.18562C8.6389 2.17216 8.46409 1.48187 8.19091 0.913486L12.4891 0.0493164Z",
    fill: "#008CFF"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6064 5.70298C19.4749 5.70298 21.6616 5.30834 21.6616 4.07399C21.6616 3.48128 21.2396 3.18562 20.7424 3.18562C19.8724 3.18562 18.7308 4.22176 18.6064 5.70298ZM18.5069 8.14759C18.5069 9.65479 19.3507 10.2461 20.4693 10.2461C21.6875 10.2461 22.8538 9.95045 24.3698 9.18525L23.7988 13.0363C22.7307 13.5546 21.0661 13.9005 19.4503 13.9005C15.3518 13.9005 13.8849 11.4318 13.8849 8.34554C13.8849 4.34545 16.271 0.0981073 21.1902 0.0981073C23.8986 0.0981073 25.413 1.60518 25.413 3.70369C25.4133 7.08674 21.0416 8.12313 18.5069 8.14759Z",
    fill: "#008CFF"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0341 3.06219C39.0341 3.55592 38.9587 4.27207 38.8837 4.74009L37.4674 13.6292H32.8715L34.1634 5.48069C34.1879 5.25968 34.2632 4.81473 34.2632 4.56786C34.2632 3.97515 33.8903 3.82725 33.4421 3.82725C32.8467 3.82725 32.2499 4.09858 31.8525 4.29666L30.3872 13.6293H25.7653L27.8768 0.320771H31.877L31.9276 1.38302C32.8713 0.765845 34.114 0.0983608 35.8771 0.0983608C38.2131 0.0981073 39.0341 1.28366 39.0341 3.06219Z",
    fill: "#008CFF"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.6781 1.55499C53.9944 0.617699 55.2373 0.0981073 56.951 0.0981073C59.3109 0.0981073 60.1318 1.28366 60.1318 3.06219C60.1318 3.55592 60.0566 4.27207 59.9816 4.74009L58.5669 13.6292H53.9697L55.2863 5.30847C55.3105 5.08606 55.3614 4.81473 55.3614 4.64263C55.3614 3.97527 54.9885 3.82725 54.5404 3.82725C53.9695 3.82725 53.3989 4.07412 52.9752 4.29666L51.5102 13.6293H46.9141L48.2307 5.30859C48.2549 5.08618 48.3043 4.81486 48.3043 4.64276C48.3043 3.9754 47.9312 3.82738 47.4846 3.82738C46.888 3.82738 46.2925 4.09871 45.895 4.29679L44.4286 13.6294H39.8083L41.9195 0.320898H45.8708L45.9949 1.43194C46.9141 0.766099 48.1558 0.0986142 49.8203 0.0986142C51.2615 0.0981073 52.2051 0.715407 52.6781 1.55499Z",
    fill: "#008CFF"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.2784 5.4319C69.2784 4.34545 69.0049 3.60472 68.1857 3.60472C66.3719 3.60472 65.9995 6.78956 65.9995 8.41879C65.9995 9.65479 66.3477 10.4197 67.1666 10.4197C68.881 10.4197 69.2784 7.06101 69.2784 5.4319ZM61.3288 8.22211C61.3288 4.0252 63.5643 0.0981073 68.7077 0.0981073C72.5833 0.0981073 74 2.37024 74 5.50642C74 9.65466 71.7887 13.9505 66.5212 13.9505C62.6206 13.9505 61.3288 11.4071 61.3288 8.22211Z",
    fill: "#008CFF"
  }));
};
var _default = exports.default = venmologo;